import { Injectable } from '@angular/core';

export type Product = {
  name: string,
  selected: boolean,
  uuid: string
}
@Injectable({
  providedIn: 'root'
})
export default class ProductsService {
  protected products: Product[] = [
    {
      name: "ADA",
      selected: false,
      uuid: "u13rxb35obe"
    },
    {
      name: "FMLA",
      selected: false,
      uuid: "gcs04dp3lnu"
    },
    {
      name: "STD",
      selected: false,
      uuid: "dssee"
    },
    {
      name: "LTD",
      selected: false,
      uuid: "gcs04dp3lnu"
    },
    {
      name: "LOA",
      selected: false,
      uuid: "gcs04dp3lnu"
    },
    {
      name: "All Solutions",
      selected: false,
      uuid: "gcs04dp3lnu"
    },
  ]
  constructor() { }

  getAllProducts(): Product[] {
    return this.products;
  }
  getProductByName(name: string): Product | undefined {
    return this.products.find((product) => product.name === name);
  }
}
